<template>
  <v-snackbar v-model="snackbar" text :color="color" timeout="3000" top right>
    <h4>{{ title }}</h4>
    <hr class="my-2" />
    <div v-for="(msg, m) in msg" :key="m">
      {{ msg }}
    </div>
    <!-- close btn -->
    <template v-slot:action="{ attrs }">
      <v-btn icon :color="color" v-bind="attrs" @click="snackbar = false">
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </template>
  </v-snackbar>
</template>

<script>
export default {
  props: ['title', 'msg', 'color'],
  data() {
    return {}
  },
  computed: {
    snackbar: {
      get() {
        return this.msg.length > 0
      },
      set(val) {
        this.$store.commit('setToastMsg', { title: '', msg: [], color: '' })
        return val
      },
    },
  },
}
</script>
